import { render, staticRenderFns } from "./CoursewareStructuralElementPermissions.vue?vue&type=template&id=6d5ce1ed&"
import script from "./CoursewareStructuralElementPermissions.vue?vue&type=script&lang=js&"
export * from "./CoursewareStructuralElementPermissions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports